import { Colors, Media } from 'enums';
import styled from 'styled-components';
import { Button, Text, TextArea } from 'view/atoms';

type LabelStyledProps = {
  isOnDiscountPage?: boolean;
};

export const StyledTextAreaInModal = styled(TextArea)`
  overflow-y: auto;
  border-radius: 10px;
  height: 120px;
  background-color: ${Colors.gray5};
`;

export const LikeCounterStyle = styled.div<LabelStyledProps>`
  height: auto;
  border-radius: 6px;
  display: flex;
  gap: 8px;
  z-index: 1;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  right: 0px;
  @media ${Media.notebook} {
    height: 40px;
    padding: 11px 16px;
  }
`;

export const LikeCounterButton = styled(Button)`
  display: flex;
  gap: 8px;
  padding: 0 8px;
  height: 36px;
  width: auto;
`;

export const DislikeCommentErrorText = styled(Text)`
  text-align: left;
  margin-top: 4px;
`;
